<script setup>
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
const networks = {
  Allego: "allego",
  Belib: "belib",
  "BP Europa SE": "bp-europa-se",
  Carrefour: "carrefour",
  DRIVECO: "driveco",
  eborn: "e-born",
  Electra: "electra",
  EnBW: "enbw",
  Eneco: "eneco",
  "Enel X": "eneldrive",
  Fastned: "fastned",
  Freshmile: "freshmile",
  Iberdrola: "iberdrola",
  Ionity: "ionity",
  Izivia: "izivia",
  Lidl: "lidl",
  "Power Dot": "power-dot",
  "Shell Recharge": "shell",
  TotalEnergies: "total",
  "Tesla Superchargeurs": "tesla-motors"
};
</script>

<template>
    <div class="network-list">
        <div class="title">{{ $t("footer.networks") }}</div>
        <ul>
            <li
                v-for="[name, slug] of Object.entries(networks)"
                :key="slug"
                class="w-fit"
            >
                <NuxtLink
                    external
                    :to="`/${language}-${country}/networks/${slug}`"
                    :title="name"
                >
                    {{ name }}
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<style scoped>
.network-list .title {
  @apply font-bold text-[15px] py-2 pr-4 text-sky-700 hidden md:block mx-auto mt-6 w-fit;
}
.network-list ul {
  @apply px-4 pb-4 md:py-9 md:px-14 grid grid-flow-col grid-rows-10 md:grid-rows-5 gap-2 md:gap-y-2.5 md:gap-x-4 lg:max-w-[1280px] mx-auto md:justify-between;
}
.network-list a {
  @apply flex text-zinc-700 hover:text-sky-400 active:text-sky-700 active:font-semibold disabled:text-zinc-400 whitespace-nowrap text-ellipsis text-[13px] lg:text-[15px];
}
</style>
